import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import { SocialIcons } from './SocialIcons';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/dmEeVyCNLLsP1vKt5zN2GP/logo_de_la_ruta.jpg';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-barber-black border-t border-white/10 pt-16 pb-8 px-6 md:px-12" data-id="element-74">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-12 mb-12" data-id="element-75">
        <div data-id="element-76">
          <img src={LOGO_URL} alt="JP Barber Mobile Supply" className="w-24 h-24 object-contain rounded-xl mb-4" data-id="element-77" />
          <p className="text-gray-400 mb-6" data-id="element-78">{t.footer.desc}</p>
          <SocialIcons data-id="element-79" />
        </div>

        <div data-id="element-80">
          <h4 className="font-oswald text-xl font-bold mb-4" data-id="element-81">
            {t.footer.areasTitle}
          </h4>
          <ul className="space-y-2 text-gray-400" data-id="element-82">
            <li data-id="element-83">Bronx</li>
            <li data-id="element-84">Brooklyn</li>
            <li data-id="element-85">Manhattan</li>
            <li data-id="element-86">Queens</li>
            <li className="pt-2 border-t border-white/10 mt-2 text-white font-medium" data-id="element-87">
              City of Waterbury, CT
            </li>
          </ul>
        </div>

        <div data-id="element-88">
          <h4 className="font-oswald text-xl font-bold mb-4" data-id="element-89">
            {t.footer.contactTitle}
          </h4>
          <ul className="space-y-3 text-gray-400" data-id="element-90">
            <li className="flex items-center gap-2" data-id="element-91">
              <MessageCircle size={18} className="text-barber-gold" data-id="element-92" />
              <a href="https://wa.me/17185824903" target="_blank" rel="noopener noreferrer" className="hover:text-barber-gold transition-colors" data-id="element-93">
                WhatsApp: 718-582-4903
              </a>
            </li>
            <li className="flex items-center gap-2" data-id="element-94">
              <Phone size={18} className="text-barber-gold" data-id="element-95" />
              <a href="tel:+17185824903" className="hover:text-barber-gold transition-colors" data-id="element-96">
                Tel: 718-582-4903
              </a>
            </li>
            <li className="mt-4 pt-4 border-t border-white/10" data-id="element-97">
              <span className="block text-white font-medium mb-1" data-id="element-98">
                {t.footer.hoursTitle}
              </span>
              {t.footer.hours}
              <br data-id="element-99" />
              7:00 AM – 9:00 PM
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto text-center pt-8 border-t border-white/10 text-gray-500 text-sm" data-id="element-100">
        <p data-id="element-101">
          © {new Date().getFullYear()} JP Barber Mobile Supply.{' '}
          {t.footer.rights}
        </p>
      </div>
    </footer>;
}